<div class="wrapper">
  <div style="display: flex; align-items: center; gap: 0.5rem;" class="sub-title required">
    <mat-icon *ngIf="getErrors(insideSurveyInsideInfo.TELCO_ROOM_SUBTITLE)" style="color: red;">
      warning
    </mat-icon>
    <div i18n="@@survey.inside.technicalinfo.inside.section.header.telco">
      Telco Room
    </div>
  </div>
  <div class="section">
    <app-photo-and-remark [photos]="pictures.telcoRoomPhotos" [surveyId]="survey.id" [limit]="75"
      [isAuthCanWrite]="isAuthCanWrite" [surveyPhotoType]="11" [isInsidePhoto]="true" [camera]="camera"
      [cameraLayer]="cameraLayer" [surveyType]="surveyType.Inside" [surveyPhotoType]="surveyPhotoType.TelcoRoom"
      [remarkFieldName]="telcoRoomPhotoRemarkFieldName" componentDescriptionTitle="Telco Room">
    </app-photo-and-remark>
  </div>
  <div style="display: flex; align-items: center; gap: 0.5rem;" class="sub-title required">
    <mat-icon *ngIf="getErrors(insideSurveyInsideInfo.PROXIMUS_EQUIPMENT_SUBTITLE)" style="color: red;">
      warning
    </mat-icon>
    <div i18n="@@survey.inside.technicalinfo.inside.section.telco.proximusequipment">
      Proximus equipment
    </div>
  </div>

  <div class="section">
    <app-photo-and-remark [photos]="pictures.proximusEquipmentPhotos" [surveyId]="survey.id" [limit]="75"
      [isAuthCanWrite]="isAuthCanWrite" [surveyPhotoType]="12" [isInsidePhoto]="true" [camera]="camera"
      [cameraLayer]="cameraLayer" [surveyType]="surveyType.Inside" [surveyPhotoType]="surveyPhotoType.ProximusEquipment"
      [remarkFieldName]="proximusEquipmentPhotoRemarkFieldName" componentDescriptionTitle="Proximus Equipment">
    </app-photo-and-remark>
  </div>
  <div class="sub-title" i18n="@@general.generalremarks">General remarks</div>
  <div class="section remarks-section" [formGroup]="accessToTelcoForm">
    <textarea [readonly]="!this.isAuthCanWrite" formControlName="accessToTelcoGeneralRemarks" placeholder="add remarks"
      maxlength="300"></textarea>
  </div>
</div>